import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("erfKF"), parcelRequire.load("9f8mp"), parcelRequire.load("hVSpU"), parcelRequire.load("9wnLi"), parcelRequire.load("aQuwV"), parcelRequire.load("dY2Rk"), parcelRequire.load("6Lk8i")]).then(() => {
  return Promise.all([waitForCSS("https://reactspectrum.blob.core.windows.net/reactspectrum/4ece29f20908477518eef4d97057b7f989ade39e/s2-docs/error.c778a661.css")]);
}).then(() => {
let originalModule = parcelRequire("fxMzH");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("erfKF")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9f8mp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("hVSpU")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9wnLi")} />
  <link rel="modulepreload" href={parcelRequire.resolve("aQuwV")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dY2Rk")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6Lk8i")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
